// i18n labels for shipping methods and product categories.
// The API (/api/content.store_info.shipping_rates) sends canonical IDs
// only — these maps render them in EN/AR/FR for the public calculators
// and the /shipping-rates embed. Keep these in sync with seed_data.py
// when adding new canonical categories.

export const METHOD_LABELS = {
  air:       { en: "Air Freight",      ar: "شحن جوي",                  fr: "Fret aérien" },
  sea:       { en: "Sea Freight",      ar: "شحن بحري",                 fr: "Fret maritime" },
  land:      { en: "Land Freight",     ar: "شحن بري",                  fr: "Fret terrestre" },
  hk_air:    { en: "HK Air Freight",   ar: "شحن جوي عبر هونغ كونغ",     fr: "Fret aérien via HK" },
  under_5kg: { en: "Air & Sea (<5kg)", ar: "جوي وبحري (أقل من 5 كغ)",  fr: "Aérien & maritime (<5kg)" },
  shein:     { en: "SHEIN",            ar: "شي إن",                    fr: "SHEIN" },
  office:    { en: "Office",           ar: "مكتب",                     fr: "Bureau" },
  standard:  { en: "Standard",         ar: "قياسي",                    fr: "Standard" },
  express:   { en: "Express",          ar: "سريع",                     fr: "Express" },
};

export const METHOD_ICONS = {
  air:    "✈️",
  sea:    "🚢",
  land:   "🚛",
  hk_air: "✈️",
  under_5kg: "📦",
  shein:  "🛍️",
  office: "📞",
};

export const CATEGORY_LABELS = {
  general:                { en: "General goods",                ar: "بضائع عادية",                fr: "Marchandises générales" },
  cosmetics:              { en: "Cosmetics",                    ar: "مستحضرات تجميل",             fr: "Cosmétiques" },
  perfumes:               { en: "Perfumes",                     ar: "عطور",                       fr: "Parfums" },
  perfumes_cosmetics:     { en: "Perfumes & Cosmetics",         ar: "العطور ومستحضرات التجميل",   fr: "Parfums & Cosmétiques" },
  supplements:            { en: "Supplements",                  ar: "مكمّلات غذائية",             fr: "Compléments alimentaires" },
  electronics:            { en: "Electronics",                  ar: "إلكترونيات",                 fr: "Électronique" },
  clothes_turkish_brands: { en: "Turkish brand clothing",       ar: "ملابس ماركات تركية",         fr: "Vêtements de marques turques" },
  clothes_intl_brands:    { en: "International brand clothing", ar: "ملابس ماركات عالمية",        fr: "Vêtements de marques internationales" },
  clothes_shoes:          { en: "Clothes & Shoes",              ar: "ملابس وأحذية",               fr: "Vêtements & Chaussures" },
  clothes_shoes_kg:       { en: "Clothes & Shoes (per kg)",     ar: "ملابس وأحذية (للكيلو)",      fr: "Vêtements & Chaussures (par kg)" },
  medical:                { en: "Medical products",             ar: "لوازم طبية",                 fr: "Produits médicaux" },
  home:                   { en: "Home products",                ar: "أغراض منزلية",               fr: "Articles pour la maison" },
  toys_stationery:        { en: "Toys / Stationery",            ar: "ألعاب وقرطاسية",             fr: "Jouets / Papeterie" },
  with_battery:           { en: "Items with battery",           ar: "منتجات تحتوي بطارية",        fr: "Articles avec batterie" },
};

// Convert an ETA string like "10-14 days" to a language-specific
// rendering. The API stores only English (`days`), so we substitute
// the unit word for AR/FR. Numbers and dashes are unchanged.
export function translateEta(eta, lang) {
  if (!eta || lang === "en") return eta || "";
  const unitMap = {
    ar: { days: "يوم", day: "يوم" },
    fr: { days: "jours", day: "jour" },
  };
  return eta.replace(/\b(days?)\b/gi, (m) => {
    const lower = m.toLowerCase();
    return (unitMap[lang] && unitMap[lang][lower]) || m;
  });
}

// Format a price+unit suffix in the requested language.
export function formatPriceUnit(unit, lang) {
  const u = (unit || "kg").toLowerCase();
  if (u === "cbm" || u === "m3") {
    return { en: "/ m³", ar: "/ م³", fr: "/ m³" }[lang] || "/ m³";
  }
  return { en: "/ kg", ar: "/ كغ", fr: "/ kg" }[lang] || "/ kg";
}
